import { getAuthenticatedFetch } from "../../msal/authenticatedFetchService";

class OrganisationService {
    async getAllOrganisations() {
        let url = `${process.env.REACT_APP_SELF_SERVICE_POLICIESANDPROCEDURES_API_URL}/Organisation`;
        let response = await getAuthenticatedFetch()(url);
        return await response.json();
    }

    async generateDataExport(organisationId: string, environmentName: string) {
        let params = `organisationId=${organisationId}&environmentName=${environmentName}`
        let url = `${process.env.REACT_APP_SELF_SERVICE_POLICIESANDPROCEDURES_API_URL}/Organisation/ExportData?${params}`;
        let response = await getAuthenticatedFetch()(url);

        const contentDisposition = response.headers.get('content-disposition');
        let filename = 'nofilenamefound.zip';
        if (contentDisposition) {
            const matches = /filename\*=UTF-8''([^;]+)/.exec(contentDisposition);
            if (matches && matches[1]) {
                filename = decodeURIComponent(matches[1]);
            }
        }
        
        const blob = await response.blob()

        return {blob, filename};
    }

    async requestSoftDelete(organisationId: string, environmentName: string, reason: string) {
        const response = await getAuthenticatedFetch()(`${process.env.REACT_APP_SELF_SERVICE_POLICIESANDPROCEDURES_API_URL}/Organisation/softdeleterequest`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                reason,
                organisationId,
                environmentName
            })
        });

        if (!response.ok) {
            throw new Error();
        }

        return response.json();
    }

    async SoftDeleteStatus(taskId: string) {
        let url = `${process.env.REACT_APP_SELF_SERVICE_POLICIESANDPROCEDURES_API_URL}/Organisation/softdeletestatus?` +
            `taskId=${encodeURIComponent(taskId)}`;
        let response = await getAuthenticatedFetch()(url);

        if (!response.ok) {
            throw new Error();
        }

        return response.json();
    }

    async getTerminations() {
        let url = `${process.env.REACT_APP_SELF_SERVICE_POLICIESANDPROCEDURES_API_URL}/Organisation/terminations`;
        let response = await getAuthenticatedFetch()(url);

        if (!response.ok) {
            throw new Error();
        }

        return response.json();
    }

    async revertSoftDelete(environmentName: string, organisationId: string) {
        let url = `${process.env.REACT_APP_SELF_SERVICE_POLICIESANDPROCEDURES_API_URL}/Organisation/revertsoftdelete`;
        let response = await getAuthenticatedFetch()(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                environmentName,
                organisationId
            })
        });

        if (!response.ok) {
            throw new Error();
        }

        return response;
    }

    async deleteOrganisation(environmentName: string, organisationId: string, reason: string) {
        const response = await getAuthenticatedFetch()(`${process.env.REACT_APP_SELF_SERVICE_POLICIESANDPROCEDURES_API_URL}/Organisation/delete`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                environmentName,
                organisationId,
                reason
            })
        });

        if (response.status !== 200 || !response.ok) {
            throw new Error();
        }
        
        return response;
    }
}

export default new OrganisationService();
